export default {
  userName: 'xxoo',
  userIcon: 'https://passport.tutuapp.com/ucenter/avatar.php?uid=3716847',
  roleName: '运营人员',
  department: '运营部',
  permissionList: [
    {
      label: '应用信息',
      children: [
        {
          label: 'IOS',
          children: []
        },
        {
          label: 'Android',
          children: [
            {
              label: '新增',
              children: []
            }
          ]
        },
        {
          label: '应用详情页',
          children: []
        }
      ]
    },
    {
      label: '内容管理',
      children: [
        {
          label: 'IOS',
          children: []
        },
        {
          label: 'Android',
          children: [
            {
              label: '新增',
              children: []
            }
          ]
        },
        {
          label: '应用详情页',
          children: []
        }
      ]
    }
  ],
  reason: '无',
  commitList: [
    // 按提交时间排序
    {
      user: 'huhua',
      commitTitle: '提交审核',
      commitTime: '2020/05/02 13:22:22',
      commitResult: '审核不通过',
      confirmTime: '2020/05/01 14:23:10'
    },
    {
      user: 'huhua',
      commitTitle: '第二次提交审核',
      commitTime: '2020/05/02 13:22:22',
      commitResult: '审核通过',
      confirmTime: '2020/05/03 14:23:10'
    }
  ]
}
